<template>
  <div>
    <recrutest-banner :showResult="true" />
    <div class="profile-detail--card">
      <div class="profile-detail--card__profile">
        <feather-icon
          svgClasses="h-10 w-10 text-primary"
          icon="InfoIcon"
        />
        <div class="profile-detail-card__content no-margin">
          <p >
            Oportunidades para você
          </p>
          <vs-button
            color="primary"
            type="flat"
            @click="handleReapplyClick"
            style="height: auto"
          >
            <strong>Confira outras oportunidades com base no seu perfil</strong>
          </vs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 16px;">
      <DiversityBanner />
    </div>
  </div>
</template>

<script>
import RecrutestBanner from '../RecrutestBanner.vue';
import DiversityBanner from '../DiversityBanner.vue';

export default {
  name: "profile-detail-card",
  components: {
    RecrutestBanner,
    DiversityBanner,
  },
  methods: {
    handleReapplyClick() {
      // Adiciona o rastreamento do Woopra
      window.woopra.track("similar-jobs-click", {});

      // Redireciona para a página desejada
      this.$router.push({ name: 'dashboard-vacancy' });
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/profiledetailcard.scss";
</style>
